$(document).on('click',function (event) {
    var target = $(event.target);
    var targetParent = $(event.target).parent();
    if(!target.hasClass("js-toggle_menu") && $(".js-toggle_menu").hasClass("header_icon-burger-active")){
        $(".js-toggle_menu").removeClass("header_icon-burger-active");
        $(".js-toggle_menu-target").hide(100);
    }

    if(!target.hasClass("js-header_nav_icon") && !target.hasClass("header_nav_link_text")&& !targetParent.hasClass("js-header_nav") &&  $(".js-header_nav_icon").hasClass("header_nav_link_icon-up")){
        $(".js-header_nav_icon").removeClass("header_nav_link_icon-up");
        $(".js-header_nav-target").hide(100);
    }
});

$(".js-toggle_menu").on("click", function () {
    $(".js-toggle_menu").toggleClass("header_icon-burger-active");
    $(".js-toggle_menu-target").toggle(100);
});

$(".js-header_nav").on("click", function (e) {
    e.preventDefault();
    $(".js-header_nav_icon").toggleClass("header_nav_link_icon-up");
    $(".js-header_nav-target").toggle(100);
});

$(document).on('scroll',function() {
    var y = $(this).scrollTop();
    if (y > 640) {
        $('.js-scroll_button_link').fadeIn();
    } else {
        $('.js-scroll_button_link').fadeOut();
    }
});

$(function() {
    $('a[href*="#"]:not([href="#"])').on('click',function() {
        if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
            var target = $(this.hash);
            target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
            if (target.length) {
                $('html, body').animate({
                    scrollTop: target.offset().top
                }, 500);
                return false;
            }
        }
    });
});